<template>
    <div class="bento-layout idle">
        <!-- Status & Info Container -->
        <div class="bento-header">
            <div class="bento-status full-width">
                <div class="status-label">Bereit</div>
                <div class="status-value">Artikel einlagern</div>
            </div>
        </div>

        <!-- Preview Container - Shows Scan Animation -->
        <div class="bento-preview">
            <div class="preview-content preview-idle">
                <v-icon size="64" color="#1976d2" class="pulse-icon">mdi-qrcode-scan</v-icon>
                <div class="scan-animation-box">
                    <div class="scan-line"></div>
                </div>
            </div>
        </div>

        <!-- Message Container -->
        <div class="bento-message">
            <v-icon color="white" size="20">mdi-barcode-scan</v-icon>
            <span>Scannen Sie den Artikel-QR-Code</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'IdleState'
};
</script>

<style scoped>
/* Bento Layout - Responsive Grid */
.bento-layout {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    min-height: 0;
    overflow: hidden;
    gap: 8px;
    padding: 8px;
    box-sizing: border-box;
    background: #ffffff !important;
}

/* Idle Theme */
.bento-layout.idle .bento-status {
    background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
}

.bento-layout.idle .bento-message {
    background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
}

/* Header: Status & Regal */
.bento-header {
    flex-shrink: 0;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    height: auto;
}

.bento-status {
    border-radius: 8px;
    padding: 6px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: white;
    text-align: center;
}

.bento-status.full-width {
    grid-column: 1 / -1;
}

.status-label {
    font-size: clamp(8px, 2vw, 10px);
    opacity: 0.9;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.status-value {
    font-size: clamp(12px, 3.5vw, 16px);
    font-weight: bold;
    margin-top: 2px;
}

/* Preview Container - Flexible */
.bento-preview {
    flex: 1;
    min-height: 0;
    background: white;
    border-radius: 8px;
    border: 2px solid #e0e0e0;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
}

.preview-content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 8px;
    gap: 20px;
}

.scan-animation-box {
    width: clamp(120px, 40vw, 200px);
    height: clamp(120px, 40vw, 200px);
    position: relative;
    border: 3px solid #1976d2;
    border-radius: 12px;
}

.scan-line {
    position: absolute;
    width: 100%;
    height: 4px;
    background: #1976d2;
    animation: scan 2s ease-in-out infinite;
}

@keyframes scan {
    0%, 100% {
        top: 0;
        opacity: 0.8;
    }
    50% {
        top: calc(100% - 4px);
        opacity: 0.3;
    }
}

/* Message Container */
.bento-message {
    flex-shrink: 0;
    border-radius: 8px;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: white;
    font-size: clamp(11px, 2.8vw, 14px);
    font-weight: 500;
}

.pulse-icon {
    animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
    0%, 100% {
        transform: scale(1);
        opacity: 1;
    }
    50% {
        transform: scale(1.1);
        opacity: 0.7;
    }
}

/* Responsive adjustments */
@media (max-width: 480px) {
    .bento-layout {
        gap: 6px;
        padding: 6px;
    }

    .bento-header {
        gap: 6px;
    }

    .bento-status {
        padding: 5px;
    }

    .preview-content {
        padding: 4px;
        gap: 16px;
    }

    .bento-message {
        padding: 6px;
        gap: 6px;
    }

    .scan-animation-box {
        border-width: 2px;
    }
}
</style>
